module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "moveup",
      "mode": "out-in",
      "appear": ""
    }
  }, [(!_vm.isHistoryVisible) ? _c('div', {
    key: 'historyInvisible',
    staticClass: "body"
  }, [_c('div', {
    staticClass: "search-input-container"
  }, [_vm._l((_vm.mySites), function(site, siteId) {
    return _c('div', {
      key: siteId,
      staticClass: "instruction-text",
      on: {
        "click": function($event) {
          _vm.getSiteCameras(siteId)
        }
      }
    }, [_vm._v(_vm._s(site.name))])
  }), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    staticClass: "mac-input",
    attrs: {
      "type": "text",
      "placeholder": "Enter mac address"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.goToHome()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "connect-btn",
    on: {
      "click": function($event) {
        _vm.test()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "action-btns"
  }, [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        _vm.showHistory()
      }
    }
  }, [_vm._v("View history")])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.isHistoryVisible) ? _c('div', {
    key: 'historyVisible',
    staticClass: "body"
  }, [_c('div', {
    staticClass: "search-input-container"
  }, [_c('div', {
    staticClass: "history-container"
  }, [_c('div', {
    staticClass: "description-text"
  }, [_vm._v("Recently connected...")]), _vm._v(" "), _c('div', {
    staticClass: "bridges"
  }, _vm._l((_vm.mockupMacAddresses), function(mac, index) {
    return (index < 5) ? _c('div', {
      key: mac,
      staticClass: "bridge-btn",
      on: {
        "click": function($event) {
          _vm.goToHome()
        }
      }
    }, [_vm._v(_vm._s(mac))]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "action-btns"
  }, [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        _vm.hideHistory()
      }
    }
  }, [_vm._v("Hide history")])])])]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "logo-text"
  }, [_vm._v("CHeKT Bridge")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fd0bbd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 278
// module chunks = 1